import { Component, Input, OnInit } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { Subject } from 'app/shared/models/subject';
import { Referral } from 'app/shared/models/referral';
import { CategoryService } from 'app/shared/services/category.service';
import {
  TranslationService,
  Language,
} from 'app/shared/services/translation.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'referral-widget',
  templateUrl: './referral-widget.component.html',
  styleUrls: ['./referral-widget.component.scss'],
  animations: fuseAnimations,
})
export class ReferralWidgetComponent implements OnInit {
  widgetTitle: string;
  secondaryWidgetTitle: string;
  referral: Referral;
  subjectData: Subject;
  sourceId: number;
  categoryId: number;
  categoryDescription: string;
  uniqueReference?: any;
  reportDetails?: any;

  language: Language;
  showTranslation = false;

  constructor(
    private categoryService: CategoryService,
    private translationService: TranslationService
  ) {
    this.language = localStorage.getItem('preferredLang')
      ? JSON.parse(localStorage.getItem('preferredLang'))
      : this.translationService.defaultLanguage;

    this.showTranslation = localStorage.getItem('showTranslation')
      ? JSON.parse(localStorage.getItem('showTranslation'))?.showTranslation
      : false;
  }

  ngOnInit(): void {
    this.widgetTitle = 'Referral Details';
  }

  //added empty inputs to remove errors - YA
  @Input() id: Number;
  @Input() subjectId: Number;
  @Input() title: any;
  @Input() secondaryTitle: any;
  @Input() processTypeId: Number;
  @Input() settings: any;

  @Input() set subject(s: Subject) {
    this.subjectData = s;
    if (s.referral) {
      this.referral = s.referral;
      this.secondaryWidgetTitle = this.referral.summary;
      if (s.categoryId) {
        this.categoryId = s.categoryId;
        this.categoryDescription = this.categoryService.getDescription(
          this.categoryId
        );
      }

      // when the components are made, i will be pasing the reportDetails to it based on the
      // referral.referralSourceId
      if (this.referral.reportJson) {
        this.reportDetails = JSON.parse(this.referral.reportJson);
      }
    }
  }

  public get showTranslationControls(): boolean {
    var rc=this.referral?.referralSource 
          && ((this.referral?.referralSource.name === 'File a Concern Website' ) 
              || (this.referral?.referralSource.name === 'ReportAFraud Website' && environment.enableRAFTranslate) 
              || (this.referral?.referralSource.name === 'Freedom to Speak Up Website' && environment.enableFTSUTranslate) 
              )
          && this.referral?.reportJson;
    return rc;
  }

  get onlineReportingReferral() {
    return (
      this.referral &&
      this.referral.referralSource &&
      (this.referral.referralSource.name === 'File a Concern Website' ||
        this.referral.referralSource.name === 'Freedom to Speak Up Website' ||
        this.referral.referralSource.name === 'ReportAFraud Website')
    );
  }

  onLanguageChange(language: Language) {
    this.language = language;
    localStorage.setItem('preferredLang', JSON.stringify(language));
  }

  onShowTranslationChange(showTranslation: boolean) {
    this.showTranslation = showTranslation;
    localStorage.setItem(
      'showTranslation',
      JSON.stringify({ showTranslation: showTranslation })
    );
  }
}
